import { useCallback, useState } from 'react';
import { API_BASE_URL } from '@/config/serverConfig';
import { useAuth } from '@/contexts/useAuth';
import { useToast } from '@/contexts/ToastContext';
import { Button } from '@/components/ui/Button/Button';
import { parseAuthSessionBody, type AuthSessionResponseBody } from '@/types/access';
import { api } from '@/api/client';
import './AccessPreviewBanner.css';

export function AccessPreviewBanner() {
  const { preview, setSession } = useAuth();
  const { showError } = useToast();
  const [exiting, setExiting] = useState(false);

  const handleExit = useCallback(async () => {
    setExiting(true);
    try {
      await api.access.previewExit();
      const res = await fetch(`${API_BASE_URL}/auth/verify`, { credentials: 'include' });
      const data = (await res.json().catch(() => null)) as AuthSessionResponseBody | null;
      const session = data ? parseAuthSessionBody(data) : null;
      if (res.ok && session) {
        setSession(session);
        return;
      }
      showError('Не удалось обновить сессию после выхода из превью');
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Не удалось выйти из превью';
      showError(message);
    } finally {
      setExiting(false);
    }
  }, [setSession, showError]);

  if (!preview) return null;

  return (
    <div className="access-preview-banner" role="status" aria-live="polite">
      <p className="access-preview-banner__text">{preview.explanation}</p>
      <Button
        type="button"
        variant="outlined"
        size="s"
        className="access-preview-banner__exit"
        onClick={() => void handleExit()}
        disabled={exiting}
      >
        {exiting ? 'Выход…' : 'Выйти'}
      </Button>
    </div>
  );
}
